module.exports = __webpack_public_path__ + "static/img/chair-zhenxin.dc1aadd4.png";